import { useQuery } from '@tanstack/react-query';

import { Account as AccountAPI } from '@air/api';
import { type Succeeded } from '@air/server-sdk';
import {
  callOnFullAccountUserPool,
  configureAPIPackage,
  configureAPIPackageForAnonymousSignUp,
  useIsLoggedIn,
} from '@air/utils-auth';

import { getActiveUserSessionType } from '~/utils/auth/getActiveUserSessionType';

export const NO_CURRENT_USER_ERROR = 'No current user';

export const ACCOUNT = 'ACCOUNT';

export type AccountGetResponse = Succeeded<typeof AccountAPI.get>;

export const getAccountKey = () => {
  return [ACCOUNT];
};

export const useAccount = () => {
  const { isLoggedIn } = useIsLoggedIn();

  return useQuery({
    queryKey: getAccountKey(),
    queryFn: () => callOnFullAccountUserPool(AccountAPI.get),
    staleTime: Infinity,
    enabled: isLoggedIn,
  });
};

export const usePublicAccount = () => {
  return useQuery({
    queryKey: getAccountKey(),

    queryFn: async () => {
      const existingAccountType = await getActiveUserSessionType();

      if (existingAccountType === 'none') {
        return null;
      } else if (existingAccountType === 'full') {
        configureAPIPackage();
        return AccountAPI.get();
      } else if (existingAccountType === 'anonymous') {
        configureAPIPackageForAnonymousSignUp();
        return AccountAPI.get();
      }
    },
    staleTime: Infinity,
  });
};
